import React from 'react';
import { Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import Widgets from './Widgets';
import TicketsData from './TicketsData';


const ListView = () => {
    document.title="Tickets | Painel Líder Fibra";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>                    
                    <BreadCrumb title="Lista de Tickets" pageTitle="Tickets" />
                    {/* <Row>
                        <Widgets />
                    </Row> */}
                    <TicketsData />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ListView;